/* =====================================================================
   VELURA — lógica de cada sección (se registra en Velura.modules y
   la arranca vl-motion.js al encontrar data-vl-module="nombre")
   ===================================================================== */
(function () {
  'use strict';
  const V = (window.Velura = window.Velura || {});
  V.modules = V.modules || {};
  const desk = () => matchMedia('(min-width:990px)').matches;

  /* ---------------- HERO ---------------- */
  V.modules.hero = function (el, { G, ST, anim }) {
    if (!anim || !G || !ST) return;
    const clip = el.querySelector('[data-vl-hero-clip]');
    const img = el.querySelector('[data-vl-hero-img]');
    const cab = el.querySelector('[data-vl-hero-cab]');
    const marco = el.querySelector('[data-vl-hero-marco]');
    const parallax = el.dataset.parallax !== 'false';
    const mm = G.matchMedia();

    mm.add({ d: '(min-width:990px)', m: '(max-width:989px)' }, (ctx) => {
      const gut = getComputedStyle(document.documentElement).getPropertyValue('--vl-gut').trim() || '20px';
      const r = getComputedStyle(document.documentElement).getPropertyValue('--vl-r').trim() || '28px';
      if (el.classList.contains('vl-hero--abre') && clip) {
        const desde = ctx.conditions.d ? `inset(0px ${gut} 0px 0px round ${r})` : `inset(0px ${gut} 0px ${gut} round ${r})`;
        G.fromTo(clip, { clipPath: desde }, { clipPath: 'inset(0px 0px 0px 0px round 0px)', ease: 'none',
          scrollTrigger: { trigger: marco, start: ctx.conditions.d ? 'top 10%' : 'top 30%', end: ctx.conditions.d ? 'bottom 40%' : 'bottom 35%', scrub: true } });
      }
      if (parallax && img) {
        G.fromTo(img, { yPercent: -3, scale: 1.12 }, { yPercent: 4, scale: 1, ease: 'none',
          scrollTrigger: { trigger: marco, start: 'top bottom', end: 'bottom top', scrub: true } });
      }
      if (parallax && cab && ctx.conditions.d) {
        G.to(cab, { yPercent: -18, opacity: 0.35, ease: 'none', scrollTrigger: { trigger: el, start: 'top top', end: 'bottom top', scrub: true } });
      }
    });
  };
})();

/* ---------------- PANTALLA LED ---------------- */
(function () {
  const V = window.Velura;
  const SEG = { 0: 'abcdef', 1: 'bc', 2: 'abged', 3: 'abgcd', 4: 'fgbc', 5: 'afgcd', 6: 'afgedc', 7: 'abc', 8: 'abcdefg', 9: 'abcdfg' };
  V.led = {
    temp(svg, n) {
      if (!svg) return;
      const s = String(Math.round(n)).padStart(2, '0').slice(-2);
      if (svg.dataset.temp === s) return;
      svg.querySelectorAll('.vl-led-dig').forEach((g) => {
        const on = SEG[s[+g.dataset.pos]] || '';
        g.querySelectorAll('path').forEach((p) => p.classList.toggle('on', on.includes(p.dataset.s)));
      });
      svg.dataset.temp = s;
      svg.setAttribute('aria-label', 'Pantalla: ' + s + ' grados');
    },
    modo(svg, m) {
      if (!svg || +svg.dataset.modo === m) return;
      svg.querySelectorAll('[data-m]').forEach((e) => e.classList.toggle('on', +e.dataset.m === m));
      const v = svg.querySelector('.vl-led-vib');
      if (v) v.classList.toggle('on', m > 0);
      svg.dataset.modo = m;
    },
  };

  /* ---------------- HISTORIA CON SCROLL ---------------- */
  V.modules.historia = function (el, { G, ST, anim }) {
    const pasos = Array.from(el.querySelectorAll('.vl-hist__paso'));
    const N = pasos.length;
    const led = el.querySelector('.vl-hist__pantalla [data-vl-led]');
    if (!N) return;
    if (!anim || !G || !ST) { V.led.temp(led, 60); return; }

    const pista = el.querySelector('[data-vl-hist-pista]');
    const esc = el.querySelector('[data-vl-hist-escena]');
    const prod = el.querySelector('[data-vl-hist-prod]');
    const halo = el.querySelector('[data-vl-hist-halo]');
    const calor = el.querySelector('[data-vl-hist-calor]');
    const anilloSvg = el.querySelector('[data-vl-hist-anillo]');
    const anillo = el.querySelector('.vl-hist__anillo-prog');
    const bat = el.querySelector('[data-vl-hist-bat]');
    const carga = el.querySelector('[data-vl-hist-carga]');
    const nums = Array.from(el.querySelectorAll('.vl-hist__cuenta span'));
    const dots = Array.from(el.querySelectorAll('.vl-hist__progreso span'));

    const giros = [{ rotation: -4, scale: 0.96 }, { rotation: 0, scale: 1.07 }, { rotation: 3, scale: 1 }, { rotation: -2, scale: 0.92 }, { rotation: 0, scale: 0.88 }];
    const ledT = { v: 50 }, ledM = { m: 0 };
    const tl = G.timeline({ defaults: { ease: 'none' } });
    G.set(pasos, { autoAlpha: 0, y: 40 });
    G.set(halo, { opacity: 0.2, scale: 0.6 });

    pasos.forEach((p, i) => {
      const t = i, ef = p.dataset.efecto, ultimo = i === N - 1;
      tl.fromTo(p, { autoAlpha: 0, y: 40, filter: 'blur(8px)' }, { autoAlpha: 1, y: 0, filter: 'blur(0px)', duration: 0.22, ease: 'power2.out' }, t + 0.04);
      if (!ultimo) tl.to(p, { autoAlpha: 0, y: -30, filter: 'blur(6px)', duration: 0.18, ease: 'power2.in' }, t + 0.8);
      tl.to(prod, Object.assign({ duration: 0.5, ease: 'power1.inOut' }, giros[i % giros.length]), t);

      if (ef === 'cuenta') {
        nums.forEach((n, k) => {
          tl.fromTo(n, { autoAlpha: 0, scale: 1.12 }, { autoAlpha: 0.9, scale: 1, duration: 0.08 }, t + 0.06 + k * 0.24)
            .to(n, { autoAlpha: 0, scale: 0.92, duration: 0.08 }, t + 0.24 + k * 0.24);
        });
        tl.to(halo, { opacity: 1, scale: 1.05, duration: 0.7, ease: 'power2.in' }, t + 0.1);
        tl.to(calor, { opacity: 0.5, duration: 0.6 }, t + 0.2);
      } else if (ef === 'temperatura') {
        tl.to(ledT, { v: 60, duration: 0.7, onUpdate: () => V.led.temp(led, ledT.v) }, t + 0.1);
        tl.to(calor, { opacity: 1, duration: 0.6 }, t + 0.15);
        tl.to(halo, { scale: 1.15, duration: 0.6 }, t + 0.15);
      } else if (ef === 'vibracion') {
        tl.to(ledM, { m: 4.99, duration: 0.8, onUpdate: () => V.led.modo(led, Math.min(4, Math.floor(ledM.m))) }, t + 0.08)
          .to(ledM, { m: 0, duration: 0.02, onUpdate: () => V.led.modo(led, Math.floor(ledM.m)) }, t + 0.96);
      } else if (ef === 'bateria') {
        tl.fromTo(bat, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, duration: 0.14 }, t + 0.05)
          .fromTo(carga, { scaleX: 0 }, { scaleX: 1, duration: 0.6, ease: 'power1.inOut' }, t + 0.15);
        if (!ultimo) tl.to(bat, { autoAlpha: 0, duration: 0.12 }, t + 0.86);
      } else if (ef === 'temporizador') {
        tl.fromTo(anilloSvg, { autoAlpha: 0, scale: 0.9 }, { autoAlpha: 1, scale: 1, duration: 0.14 }, t + 0.05)
          .fromTo(anillo, { strokeDashoffset: 100 }, { strokeDashoffset: 0, duration: 0.7 }, t + 0.14);
        if (!ultimo) tl.to(anilloSvg, { autoAlpha: 0, duration: 0.12 }, t + 0.86);
      }
    });
    tl.set({}, {}, N);

    ST.create({
      trigger: pista, start: 'top top', end: 'bottom bottom', scrub: 0.5, animation: tl,
      onUpdate: (self) => {
        const p = self.progress * N, idx = Math.min(N - 1, Math.floor(p)), f = p - idx;
        dots.forEach((d, k) => d.style.setProperty('--p', Math.max(0, Math.min(1, p - k)).toFixed(3)));
        esc.classList.toggle('is-vib', pasos[idx].dataset.efecto === 'vibracion' && f > 0.08 && f < 0.95);
      },
    });
  };
})();

/* ---------------- SIMULADOR ---------------- */
(function () {
  const V = window.Velura;
  const PATRONES = { 1: [400], 2: [120, 90, 120, 90, 120], 3: [80, 60, 80, 400, 80, 60, 80], 4: [250, 120, 180, 120, 250] };
  const NIVEL = { 50: 0, 55: 0.55, 60: 1 };
  V.modules.simulador = function (el, { G, anim }) {
    const led = el.querySelector('[data-vl-led]');
    const disp = el.querySelector('[data-vl-sim-disp]');
    const calor = el.querySelector('[data-vl-sim-calor]');
    const halo = el.querySelector('[data-vl-sim-halo]');
    const ind = el.querySelector('[data-vl-sim-ind]');
    const desc = el.querySelector('[data-vl-sim-desc]');
    const temps = Array.from(el.querySelectorAll('.vl-sim__temp'));
    const modos = Array.from(el.querySelectorAll('.vl-sim__modo'));
    const vibrar = el.dataset.vibrar !== 'false' && 'vibrate' in navigator;
    const estado = { t: 50, m: 0 };
    const obj = { v: 50 };

    function ponTemp(t, i) {
      temps.forEach((b) => b.setAttribute('aria-checked', b === temps[i]));
      if (ind) ind.style.transform = 'translateX(' + i * 100 + '%)';
      if (desc) desc.textContent = temps[i].dataset.desc;
      const nivel = NIVEL[t] || 0;
      el.classList.toggle('is-hot', nivel > 0.8);
      if (anim && G) {
        G.to(obj, { v: t, duration: 0.3 + Math.abs(t - estado.t) * 0.06, ease: 'power1.out', onUpdate: () => V.led.temp(led, obj.v) });
        G.to(calor, { opacity: nivel, duration: 1.1, ease: 'power2.out' });
        G.to(halo, { opacity: 0.35 + nivel * 0.65, scale: 0.9 + nivel * 0.25, duration: 1.1, ease: 'power2.out' });
      } else {
        V.led.temp(led, t);
        if (calor) calor.style.opacity = nivel;
      }
      estado.t = t;
    }
    temps.forEach((b, i) => b.addEventListener('click', () => ponTemp(+b.dataset.t, i)));

    function ponModo(m) {
      estado.m = estado.m === m ? 0 : m;
      modos.forEach((b) => b.setAttribute('aria-pressed', +b.dataset.m === estado.m));
      disp.classList.remove('m1', 'm2', 'm3', 'm4');
      if (estado.m && anim) disp.classList.add('m' + estado.m);
      el.classList.toggle('is-vib', !!estado.m && anim);
      V.led.modo(led, estado.m);
      if (vibrar) { try { navigator.vibrate(estado.m ? PATRONES[estado.m] : 0); } catch (e) {} }
    }
    modos.forEach((b) => b.addEventListener('click', () => ponModo(+b.dataset.m)));

    // al salir de pantalla se apaga la vibración
    if ('IntersectionObserver' in window) new IntersectionObserver((en) => {
      en.forEach((x) => { if (!x.isIntersecting && estado.m) ponModo(estado.m); });
    }).observe(el);
  };
})();
